const STORAGE_KEY = 'interiorai_gemini_api_key'

export function getStoredApiKey(): string {
  if (typeof window === 'undefined') return ''
  try {
    return window.localStorage.getItem(STORAGE_KEY) || ''
  } catch {
    return ''
  }
}

export function setStoredApiKey(key: string): void {
  if (typeof window === 'undefined') return
  try {
    if (key) {
      window.localStorage.setItem(STORAGE_KEY, key)
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    // localStorage unavailable — the key simply won't persist
  }
}

export function clearStoredApiKey(): void {
  setStoredApiKey('')
}
